// extracted by mini-css-extract-plugin
var _1 = "ProgressNav_circle__XVDNM";
var _2 = "ProgressNav_large__a4SX1";
var _3 = "ProgressNav_navigation__NbeL9";
var _4 = "ProgressNav_node__iBYxU";
var _5 = "ProgressNav_selected__fvBZB";
var _6 = "ProgressNav_title__58ZSB";
export { _1 as "circle", _2 as "large", _3 as "navigation", _4 as "node", _5 as "selected", _6 as "title" }
